// extracted by mini-css-extract-plugin
export default {"container":"Introduction_container__RBRnF","my_image":"Introduction_my_image__cWNGZ","info":"Introduction_info__32lD+"};